import React from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";
import CloseButton from "../../../components/Button/templates/CloseButton";
import BaseModal from "../../../components/Modal/BaseModal";
import TruncatedText from "../../../components/Text/TruncatedText";
import MeetingModalContent from "./MeetingModalContent";

interface MeetingDetailsModalProps {
	isOpen: boolean;
	onClose: () => void;
	meetingId: string | null;
	meetingName?: string;
	meetingWorkspaceId?: string;
	meetingWorkspaceName?: string;
}

const MeetingDetailsModal = ({
	isOpen,
	onClose,
	meetingId,
	meetingName = "",
	meetingWorkspaceId,
	meetingWorkspaceName = "",
}: MeetingDetailsModalProps) => {
	if (!meetingId) {
		return null;
	}

	// Determine max width for handling truncation of breadcrumb items
	const totalAvailableWidth = 1264;
	const hasWorkspace = meetingWorkspaceId && meetingWorkspaceName;
	const maxItemWidth = hasWorkspace ? Math.floor(totalAvailableWidth / 2) : totalAvailableWidth;

	const breadcrumbPages = [
		...(hasWorkspace
			? [
					{
						pageID: "workspace",
						label: (
							<TruncatedText
								text={meetingWorkspaceName}
								maxWidth={maxItemWidth}
								size="paragraph-2"
								weight="regular"
								color="neutral-7"
								strategy="fixed"
								tooltipPlacement="top"
								useTooltip="on-truncate"
							/>
						),
						url: `/meeting-workspaces/${meetingWorkspaceId}`,
					},
				]
			: []),
		{
			pageID: "meeting",
			label: (
				<TruncatedText
					text={meetingName}
					maxWidth={maxItemWidth}
					size="paragraph-2"
					weight="semi-bold"
					color="neutral-9"
					strategy="fixed"
					tooltipPlacement="top"
					useTooltip="on-truncate"
				/>
			),
			url: "", // Not clickable since it's the current page
		},
	];

	return (
		<BaseModal isOpen={isOpen} handleClose={onClose} size="auto" hideCloseButton={true} closeOnClickOutside={true}>
			<div className="mb-4 flex items-center justify-between">
				<Breadcrumbs pages={breadcrumbPages} forceHardReload={true} />
				<CloseButton onClick={onClose} />
			</div>
			<MeetingModalContent meetingId={meetingId} />
		</BaseModal>
	);
};

export default MeetingDetailsModal;
